import { render, staticRenderFns } from "./ChatTopMessage.vue?vue&type=template&id=9d1fef6a&scoped=true"
import script from "./ChatTopMessage.vue?vue&type=script&lang=js"
export * from "./ChatTopMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatTopMessage.vue?vue&type=style&index=0&id=9d1fef6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1fef6a",
  null
  
)

export default component.exports